/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { FieldLabel, Select, Option } from 't3-widgets'

import {
    setSelectedSubscriptionOption,
    setRmaDeviceSerialNumber,
    setContractNumber,
    setWfSubscription,
    setChoosedPropertyType,
    setLicensePlate
} from '../../../../../../../redux/actions'
import { getTooltip } from '../../../../common/operations'

import styles from '../../pages.module.css'

const RmaPage = ({ activeStep, intl, setPagerFunctions, setStep }) => {
    const dispatch = useDispatch()
    const tariffs = useSelector(state => state.tariffs.tariffs)
    const rmaDevices = useSelector(state => state.rmaDevices.rmaDevices)

    const [rmaDevice, setRmaDevice] = useState(0)

    const onNext = () => {
        dispatch(setContractNumber(rmaDevices[rmaDevice].contract.number))
        dispatch(setWfSubscription(rmaDevices[rmaDevice].contract.tariff))
        dispatch(setRmaDeviceSerialNumber(rmaDevices[rmaDevice].deviceSerialNumber))
        dispatch(setChoosedPropertyType(''))
        dispatch(setLicensePlate(''))

        setStep(activeStep + 1)
    }

    const onBack = () => {
        dispatch(setRmaDeviceSerialNumber(''))
        if (tariffs.length > 0) {
            dispatch(setSelectedSubscriptionOption(false))
        } else {
            setStep(activeStep - 1)
        }
    }

    useEffect(() => {
        setPagerFunctions({
            onBack,
            onNext,
            validator: true
        })
    }, [rmaDevice])

    const onChange = e => {
        setRmaDevice(e.target.value)
    }

    return (
        <div>
            <div className={styles['page-description']}>
                <p>{intl.translate('ap_step3_para_rmaonly')}</p>
            </div>
            <div className={styles['page-input-container']}>
                <div className={styles['input-field']}>
                    <FieldLabel
                        label={intl.translate('ap_step3_rma_label')}
                        tooltip={getTooltip(intl.translate('ap_step3_rma_label'), intl.translate('ap_step3_rma_para'))}
                    >
                        <Select
                            className={styles['select-field']}
                            key="rma-sub-model"
                            {...{ onChange, value: rmaDevice }}
                        >
                            {rmaDevices.map((item, index) => {
                                return (
                                    <Option key={index} value={index}>
                                        {item.deviceSerialNumber}
                                    </Option>
                                )
                            })}
                        </Select>
                    </FieldLabel>
                </div>
            </div>
        </div>
    )
}

RmaPage.propTypes = {
    activeStep: PropTypes.number,
    intl: PropTypes.objectOf(PropTypes.func),
    setPagerFunctions: PropTypes.func,
    setStep: PropTypes.func
}

export { RmaPage }
